import React from 'react';
import moment from 'moment';
import { Table } from '../../../common-components/Table/Table';
import { If } from '../../../common-components/If/If';
import { OrderNote } from '../../../models/OrderNote';
import { Container, GroupInformation, NoteHeader, NoteSource, NoteDate, NoteValue } from './styles';

interface ITabNotesProps {
  orderNotes?: OrderNote[];
}

type NoteItem = {
  source?: string;
  formattedDate: string;
  value: string;
}

export const TabNotes: React.FC<ITabNotesProps> = ({
  orderNotes
}) => {

  const notes = React.useMemo(() => {
    const items: NoteItem[] = [];

    if (orderNotes && orderNotes.length > 0) {
      items.push(...orderNotes.map(orderNote => {
        return {
          source: orderNote.createdBy?.name,
          formattedDate: moment(orderNote.createdAt).format('DD/MM/yyyy HH:mm:ss'),
          value: orderNote.value
        };
      }));
    }

    return (
      <Table>
        <tbody>
          {items.map((item, itemIndex) => {
            return (
              <tr key={`note-item-${itemIndex}`}>
                <td>
                  <NoteHeader>
                    <If condition={!!item.formattedDate}>
                      <NoteDate>{item.formattedDate}</NoteDate>
                    </If>
                    <NoteSource>{item.source}</NoteSource>
                  </NoteHeader>
                  <NoteValue>
                    {item.value}
                  </NoteValue>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }, [orderNotes]);

  return (
    <Container>
      <GroupInformation>
        {notes}
      </GroupInformation>
    </Container>
  );
};